import React, { useContext, useEffect, useState, useRef } from "react";
import { VideoContext } from "../../../context/videoContext";
import LoadingContent from "../../common/LoadingContent";
import VideoItemMobile from "../section/VideoItemMobile";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const VipMobile = () => {
	const { vip, loadMoreVideos, fetchVideos } = useContext(VideoContext);
	const [activeIndex, setActiveIndex] = useState(0);
	const [isCommentListVisible, setCommentListVisible] = useState(false);
	const swiperRef = useRef(null);

	useEffect(() => {
		fetchVideos("vip", true);
	}, [fetchVideos]);

	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.swiper.allowTouchMove = !isCommentListVisible;
		}
	}, [isCommentListVisible]);

	const handleOpenCommentList = () => {
		setCommentListVisible(true);
	};

	const handleCloseCommentList = () => {
		setCommentListVisible(false);
	};

	return (
		<div id="video-list-scrollable" className="w-full h-full">
			{vip.videos.length > 0 ? (
				<Swiper
					ref={swiperRef}
					className="h-full"
					direction="vertical"
					mousewheel
					onSlideChange={(swiper) => {
						setActiveIndex(swiper.activeIndex);
						const videos = document.querySelectorAll(".swiper-slide video");
						videos.forEach((video, index) => {
							if (index !== swiper.activeIndex) {
								video.pause();
							}
						});
					}}
					onReachEnd={() => loadMoreVideos("vip")}
				>
					{vip.videos.map((video, index) => (
						<SwiperSlide key={video.video_id} className="h-full">
							<VideoItemMobile
								video={video}
								isActive={index === activeIndex}
								onOpenCommentList={handleOpenCommentList}
								onCloseCommentList={handleCloseCommentList}
								isCommentListVisible={isCommentListVisible}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			) : (
				<div className="w-full h-full flex items-center justify-center">
					<LoadingContent/>
				</div>
			)}
		</div>
	);
};

export default VipMobile;
